import { defineComponent as g, ref as l, computed as h, watch as c, nextTick as b, onMounted as y, onUnmounted as C } from "vue";
import { uniqueId as E, throttle as x } from "lodash-es";
import { v as B } from "./component-library264.js";
import _ from "./component-library4.js";
import z from "./component-library3.js";
import $ from "./component-library91.js";
import k from "./component-library78.js";
const M = /* @__PURE__ */ g({
  __name: "dropdown",
  props: {
    caption: { default: void 0 },
    opened: { type: Boolean },
    disabled: { type: Boolean, default: void 0 },
    autoWidth: { type: Boolean },
    role: { default: "combobox" },
    ariaHasPopup: { type: [Boolean, String], default: "listbox" },
    label: { default: void 0 },
    isMultiSelect: { type: Boolean }
  },
  emits: ["focus", "toggle", "close"],
  setup(v, { expose: m, emit: r }) {
    const s = v, w = l(E()), n = l(!1), u = l(null), a = l(null), t = l(null), o = $(a, {
      focusFirstOnOpen: !0,
      focusOnArrowKeys: !0
    });
    o.onClose.value = () => {
      r("close"), u.value?.$el && u.value.$el.focus();
    };
    const O = h(() => ({
      "dropdown--open": o.isOpened.value
    }));
    c(
      () => s.opened,
      (e) => {
        o.isOpened.value = e || !1;
      }
    ), c(
      () => s.disabled,
      (e, i) => {
        e !== i && !e && (o.isOpened.value = !1);
      },
      { immediate: !0 }
    );
    const p = () => {
      if (!a.value?.$el) return;
      const e = a.value.$el.getBoundingClientRect(), i = window.document.body.offsetWidth;
      if (i < e.width) {
        n.value = !1;
        return;
      }
      n.value ? n.value = i - e.right < 200 : n.value = e.right > i;
    }, d = x(p, 250);
    c(o.isOpened, (e) => {
      if (r("toggle", e), !e) {
        window.removeEventListener("resize", d);
        return;
      }
      window.addEventListener("resize", d), b(() => {
        p();
      });
    }), y(() => {
      s.opened && (o.isOpened.value = !0);
    }), C(() => {
      window.removeEventListener("resize", d);
    }), o.onEsc.value = () => {
      u.value?.$el?.focus(), r("focus");
    };
    const f = (e) => {
      t.value && (t.value.innerText = "", setTimeout(() => {
        t.value && (t.value.innerText = e);
      }, 100));
    };
    return m({
      open: () => {
        o.isOpened.value = !0;
      },
      close: () => {
        o.isOpened.value = !1;
      },
      openable: o,
      announceOption: f
    }), { __sfc: !0, props: s, uid: w, showRight: n, buttonElement: u, dropdownContainerElement: a, announcementElement: t, openable: o, emit: r, containerClass: O, resizeHandler: p, throttledResizeHandler: d, announceOption: f, vOnClickaway: B.directive, Arrow: _, LinkButton: z, DropdownContainer: k };
  }
});
export {
  M as default
};
